import useFetchOptions from "../hooks/use-fetch-options.js";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters}) {
    const {
        dispatchNaturesOptions,
        dispatchNaturesGroupsOptions,
        channelNamesOptions,
        streetNamesOptions,
        placeNamesOptions,
        neighborhoodOptions,
        allSectorOptions,
    } = useFetchOptions();

    const attendanceOptions = [
        {value: "all", label: "Todos"},
        {value: "with_dispatch", label: "Com despacho"},
        {value: "without_dispatch", label: "Sem despacho"},
    ];

    const sourceOptions = [
        {value: "all", label: "Todos"},
        {value: "schedule", label: "Agendamento"},
        {value: "chat", label: "Chat"},
    ];

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                    dateFormat="LL"
                    classNameWrapper="w-full"
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                    dateFormat="LL"
                    classNameWrapper="w-full"
                />
                <SelectComponent
                    label="Atendimento"
                    wrapValues={true}
                    isClearable={false}
                    instanceId="attendance"
                    classNameWrapper="w-full"
                    options={attendanceOptions}
                    value={filters.attendance}
                    onChange={(value) => setFilters(prev => ({ ...prev, attendance: value }))}
                />
                <SelectComponent
                    label="Origem"
                    wrapValues={true}
                    isClearable={false}
                    instanceId="source"
                    classNameWrapper="w-full"
                    options={sourceOptions}
                    value={filters.source}
                    onChange={(value) => setFilters(prev => ({ ...prev, source: value}))}
                />
                <SelectComponent
                    label="Naturezas"
                    wrapValues={true}
                    isMulti={true}
                    instanceId="nature"
                    classNameWrapper="w-full"
                    options={dispatchNaturesOptions}
                    value={filters.nature}
                    onChange={(value) => setFilters(prev => ({ ...prev, nature: value}))}
                />
                <SelectComponent
                    label="Grupo de naturezas"
                    wrapValues={true}
                    isMulti={true}
                    instanceId="nature_groups"
                    classNameWrapper="w-full"
                    options={dispatchNaturesGroupsOptions}
                    value={filters.nature_groups}
                    onChange={(value) => setFilters(prev => ({ ...prev, nature_groups: value }))}
                />
                <InputForm
                    label="Solicitante"
                    id="requester"
                    classNameWrapper="w-full"
                    value={filters.requester}
                    onChange={({ target}) => setFilters(prev => ({ ...prev, requester: target.value }))}
                />
                <SelectComponent
                    label="Canais"
                    wrapValues={true}
                    isMulti={true}
                    instanceId="channel"
                    classNameWrapper="w-full"
                    options={channelNamesOptions}
                    value={filters.channel}
                    onChange={(value) => setFilters(prev => ({ ...prev, channel: value}))}
                />
                <SelectComponent
                    label="Logradouro"
                    wrapValue={true}
                    isMulti={true}
                    instanceId="street"
                    classNameWrapper="w-flex"
                    options={streetNamesOptions}
                    value={filters.street}
                    onChange={(value) => setFilters(prev => ({ ...prev, street: value }))}
                />
                <SelectComponent
                    label="Local pré-cadastrado"
                    wrapValue={true}
                    isMulti={true}
                    instanceId="place"
                    classNameWrapper="w-flex"
                    options={placeNamesOptions}
                    value={filters.place}
                    onChange={(value) => setFilters(prev => ({ ...prev, place: value }))}
                />
                <SelectComponent
                    label="Bairro"
                    wrapValue={true}
                    isMulti={true}
                    instanceId="neighborhood"
                    classNameWrapper="w-full"
                    options={neighborhoodOptions}
                    value={filters.neighborhood}
                    onChange={(value) => setFilters(prev => ({ ...prev, neighborhood: value }))}
                />
                <SelectComponent
                    label="Setor"
                    wrapValue={true}
                    isMulti={true}
                    instanceId="sector"
                    classNameWrapper="w-full"
                    options={allSectorOptions}
                    value={filters.sector}
                    onChange={(value) => setFilters(prev => ({ ...prev, sector: value }))}
                />
            </form>
        </div>
    )
}